import React from 'react';
import FilterToggleGroup, { FilterToggleRow } from '../common/list/FilterToggleGroup';

const techStatus = [
  { id: 0, value: '', label: '전체', color: null },
  { id: 1, value: '1', label: '지원요청', color: null },
  { id: 2, value: '2', label: '지원확인', color: 'info' },
  { id: 3, value: '3', label: '작업계획', color: 'warning' },
  { id: 4, value: '4', label: '완료보고', color: 'error' },
  { id: 5, value: '5', label: '결재중', color: 'secondary' },
  { id: 6, value: '6', label: '결재완료', color: 'success' },
];

// 상태 필터 - chancemng 설계(공통 FilterToggleGroup) 적용(2026-10-22).
const TechReqStatusList = ({ searchGrade, onChangeGrade }) => {
  return (
    <FilterToggleRow>
      <FilterToggleGroup label="상태" options={techStatus} value={searchGrade} onChange={onChangeGrade} />
    </FilterToggleRow>
  );
};

export default TechReqStatusList;
